module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/postcode.js
// module id = 1286
// module chunks = 0